import { render, staticRenderFns } from "./userCourseFrom.vue?vue&type=template&id=2dca0dbb&scoped=true"
import script from "./userCourseFrom.vue?vue&type=script&lang=js"
export * from "./userCourseFrom.vue?vue&type=script&lang=js"
import style0 from "./userCourseFrom.vue?vue&type=style&index=0&id=2dca0dbb&prod&lang=scss"
import style1 from "./userCourseFrom.vue?vue&type=style&index=1&id=2dca0dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca0dbb",
  null
  
)

export default component.exports